import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "promo-state"
};
const _hoisted_2 = { class: "quiz-title" };
const _hoisted_3 = { class: "quiz-description" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "day-indicators" };
const _hoisted_6 = {
    key: 1,
    class: "active-state"
};
const _hoisted_7 = { class: "quiz-header" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "quiz-info" };
const _hoisted_10 = { class: "quiz-active-title" };
const _hoisted_11 = { class: "quiz-active-description" };
const _hoisted_12 = { class: "entries-count" };
const _hoisted_13 = {
    key: 0,
    class: "day-indicators-small"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "day-number" };
const _hoisted_18 = ["src"];
const _hoisted_19 = {
    key: 2,
    class: "closed-state"
};
const _hoisted_20 = { class: "quiz-header" };
const _hoisted_21 = ["src"];
const _hoisted_22 = { class: "quiz-info" };
const _hoisted_23 = { class: "quiz-active-title" };
const _hoisted_24 = { class: "quiz-active-description" };
const _hoisted_25 = { class: "entries-count" };
import { computed, onMounted, onUpdated, getCurrentInstance, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizCard',
    props: {
        quiz: {},
        quizPoints: {},
        activeQuestionAnswered: { type: Boolean },
        answers: {}
    },
    emits: ["rules-click", "answer-click", "show-stats"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const instance = getCurrentInstance();
        const isQuizPromotional = computed(() => {
            if (!props.quiz.advertiseDateTime || !props.quiz.startDateTime) {
                return false;
            }
            const now = new Date();
            const advertiseDate = new Date(props.quiz.advertiseDateTime);
            const startDate = new Date(props.quiz.startDateTime);
            return now >= advertiseDate && now < startDate;
        });
        const isQuizActive = computed(() => {
            if (!props.quiz.startDateTime || !props.quiz.endDateTime) {
                return false;
            }
            // Check if the final question has been answered
            if (props.quiz.questions && props.quiz.questions.length > 0) {
                const finalQuestion = props.quiz.questions[props.quiz.questions.length - 1];
                const isFinalQuestionAnswered = isQuestionAnswered(finalQuestion);
                if (isFinalQuestionAnswered) {
                    return false;
                }
            }
            const now = new Date();
            const startDate = new Date(props.quiz.startDateTime);
            const endDate = new Date(props.quiz.endDateTime);
            return now >= startDate && now <= endDate;
        });
        const isQuizClosed = computed(() => {
            if (!props.quiz.endDateTime) {
                return false;
            }
            const now = new Date();
            const endDate = new Date(props.quiz.endDateTime);
            // Check if the final question has been answered
            if (props.quiz.questions && props.quiz.questions.length > 0) {
                const finalQuestion = props.quiz.questions[props.quiz.questions.length - 1];
                const isFinalQuestionAnswered = isQuestionAnswered(finalQuestion);
                if (isFinalQuestionAnswered) {
                    return true;
                }
            }
            // Check if quiz has ended
            if (now <= endDate) {
                return false;
            }
            // Check if we're still within the closed display period
            if (props.quiz.showClosedUntilDateTime) {
                const showClosedUntil = new Date(props.quiz.showClosedUntilDateTime);
                return now <= showClosedUntil;
            }
            // No showClosedUntilDateTime means show closed indefinitely
            return true;
        });
        const advertisingTitle = computed(() => props.quiz.advertisingHeader);
        const advertisingDescription = computed(() => props.quiz.advertisingDescription);
        const totalDays = computed(() => props.quiz.questions.length);
        const activeTitle = computed(() => props.quiz.tagLineHeader);
        const activeDescription = computed(() => {
            if (props.activeQuestionAnswered) {
                return "Play again tomorrow to keep up your streak!";
            }
            const todaysQuestion = props.quiz.questions.find((q) => isQuestionToday(q));
            return todaysQuestion ? todaysQuestion.dailyDescription : '';
        });
        const closedDescription = computed(() => {
            return props.quiz.closedDescription || "Now closed - we'll be contacting winners soon!";
        });
        const entries = computed(() => props.quizPoints?.total);
        const currentDay = computed(() => {
            const todaysQuestion = props.quiz.questions.find((q) => isQuestionToday(q));
            if (todaysQuestion) {
                return props.quiz.questions.indexOf(todaysQuestion) + 1;
            }
            return 0;
        });
        const allQuestions = computed(() => props.quiz.questions);
        function isQuestionAnswered(question) {
            if (!props.answers || props.answers.length === 0) {
                return false;
            }
            return props.answers.some(answer => answer.question.id === question.id);
        }
        function isQuestionToday(question) {
            if (!question || !question.startDateTime || !question.endDateTime) {
                return false;
            }
            const now = new Date();
            const startDate = new Date(question.startDateTime);
            const endDate = new Date(question.endDateTime);
            return now >= startDate && now <= endDate;
        }
        function handleCardClick() {
            if (isQuizPromotional.value) {
                emit('rules-click');
                return;
            }
            if (isQuizActive.value) {
                if (!props.activeQuestionAnswered) {
                    emit('answer-click');
                }
                else {
                    emit('show-stats');
                }
            }
            if (isQuizClosed.value) {
                emit('show-stats');
            }
        }
        function scrollToActiveDay() {
            nextTick(() => {
                const el = instance?.proxy?.$el;
                if (!el)
                    return;
                const container = el.querySelector('.day-indicators-small');
                if (!container)
                    return;
                const activeDay = container.querySelector('.day-box-small.current');
                if (!activeDay)
                    return;
                const containerWidth = container.offsetWidth;
                const activeDayLeft = activeDay.offsetLeft;
                const activeDayWidth = activeDay.offsetWidth;
                const scrollPosition = activeDayLeft - (containerWidth / 2) + (activeDayWidth / 2);
                container.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            });
        }
        onMounted(() => {
            scrollToActiveDay();
        });
        onUpdated(() => {
            scrollToActiveDay();
        });
        return (_ctx, _cache) => {
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: _normalizeClass(["quiz-card", { 'quiz-active': isQuizActive.value, 'quiz-promo': isQuizPromotional.value, 'quiz-closed': isQuizClosed.value, 'clickable': isQuizActive.value || isQuizClosed.value }]),
                elevation: "0",
                onClick: handleCardClick
            }, {
                default: _withCtx(() => [
                    (isQuizPromotional.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(advertisingTitle.value), 1),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(advertisingDescription.value), 1),
                            _createElementVNode("div", {
                                class: "rules-link",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('rules-click')), ["stop"]))
                            }, [
                                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Rules & how to play", -1)),
                                _createElementVNode("img", {
                                    src: require('@/assets/arrow-right.png'),
                                    class: "rightIcon"
                                }, null, 8, _hoisted_4)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalDays.value, (day) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: day,
                                        class: "day-box"
                                    }, _toDisplayString(day), 1));
                                }), 128))
                            ])
                        ]))
                        : (isQuizActive.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    (_ctx.quiz.thumbUrl && _ctx.activeQuestionAnswered)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _ctx.quiz.thumbUrl,
                                            class: "quiz-thumb-icon"
                                        }, null, 8, _hoisted_8))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("p", _hoisted_10, _toDisplayString(activeTitle.value), 1),
                                        _createElementVNode("p", _hoisted_11, _toDisplayString(activeDescription.value), 1)
                                    ]),
                                    _createElementVNode("div", {
                                        class: "entries-section",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.answers && _ctx.answers.length > 0 ? emit('show-stats') : null), ["stop"]))
                                    }, [
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "entries-label" }, "Entries", -1)),
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(entries.value), 1)
                                    ])
                                ]),
                                (!_ctx.activeQuestionAnswered)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allQuestions.value, (question) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: question.id,
                                                class: _normalizeClass(["day-box-small", {
                                                        'completed': isQuestionAnswered(question),
                                                        'current': question.questionNumber === currentDay.value,
                                                        'locked': !isQuestionAnswered(question) && question.questionNumber !== currentDay.value
                                                    }]),
                                                onClick: _withModifiers(($event) => (question.questionNumber === currentDay.value ? emit('answer-click') : null), ["stop"])
                                            }, [
                                                (isQuestionAnswered(question))
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: question.thumbUrl,
                                                        class: "thumb-icon"
                                                    }, null, 8, _hoisted_15))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        (question.questionNumber === currentDay.value)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: require('@/assets/quiz/peel-large.svg'),
                                                                class: "peel-corner"
                                                            }, null, 8, _hoisted_16))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("span", _hoisted_17, _toDisplayString(question.questionNumber), 1)
                                                    ], 64))
                                            ], 10, _hoisted_14));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.activeQuestionAnswered)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "rules-link",
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (emit('answer-click')), ["stop"]))
                                    }, [
                                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Answer today's question", -1)),
                                        _createElementVNode("img", {
                                            src: require('@/assets/arrow-right.png'),
                                            class: "rightIcon"
                                        }, null, 8, _hoisted_18)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : (isQuizClosed.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        (_ctx.quiz.thumbUrl)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.quiz.thumbUrl,
                                                class: "quiz-thumb-icon"
                                            }, null, 8, _hoisted_21))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("p", _hoisted_23, _toDisplayString(activeTitle.value), 1),
                                            _createElementVNode("p", _hoisted_24, _toDisplayString(closedDescription.value), 1)
                                        ]),
                                        _createElementVNode("div", {
                                            class: "entries-section",
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.answers && _ctx.answers.length > 0 ? emit('show-stats') : null), ["stop"]))
                                        }, [
                                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "entries-label" }, "Entries", -1)),
                                            _createElementVNode("div", _hoisted_25, _toDisplayString(entries.value), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["class"]));
        };
    }
});
